import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from "axios";
import { API_URL } from "../../const/api";
import {
  errorNotification,
  successNotification,
} from "../../utils/toastNotifications";
import { useTranslation } from "react-i18next";
import { selectYapeModal, selectIdTrans, setShowYape, setIdTransYape, selectmensaje, selectAnulado, setAnulado } from '../../features/modals/modalsSlice';
import ModalPago from '../modals/ModalBoth';
import { ContainerModal, InputContainer, ButtonsContainer,
  Button } from './pagoYapeElements';

const PagoYape = () => {
  const dispatch = useDispatch();
  const open = useSelector(selectYapeModal);
  const transaction_id = useSelector(selectIdTrans);
  const transaccion = transaction_id.toString();
  const mensaje = useSelector(selectmensaje);
  const [codigo, setCodigo] = useState('');
  const [loading, setLoading] = useState(false);
  const Anulado = useSelector(selectAnulado);
  const [t] = useTranslation('global');

  const handleClose = () => {
    setCodigo('');
    dispatch(setShowYape(false));
  }

  useEffect(() => {
    if (Anulado) {
     handleClose();
     dispatch(setAnulado(false));
    }
  }, [Anulado]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!codigo.trim()) {
      return errorNotification(
        "Por favor introduzca el código obtenido",
        "top-center"
      );
    }

    setLoading(true);
    let body = {
      code_confirmation: codigo,
      transaction_id: transaccion,
    };

    try {
      const res = await axios.post(API_URL + "confirmYapeDeposit", body);
      if (res.data.code === 200) {
        //successNotification(res.data.message, "top-center");
        handleClose();
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    } catch (error) {
      errorNotification(
        "Ha ocurrido un error, por favor intente de nuevo",
        "top-center"
      );
      setLoading(false);
    }
  }

  return (
    <ModalPago open={open} handleClose={handleClose} children={
      <ContainerModal>
        <form onSubmit={handleSubmit}>
        <InputContainer>
          <label htmlFor="codigo">{mensaje}</label>
        </InputContainer>
        <InputContainer>
          <input
            type="text"
            id="codigo"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value)}
            required
          />
          </InputContainer>
           <ButtonsContainer>
            <Button type="submit" disabled={loading}>
              {loading ? 'ENVIANDO...' : 'ENVIAR'}
            </Button>
          </ButtonsContainer>
        </form>
      </ContainerModal>
    } />
  )
}

export default PagoYape;
